<template>
  <section class="unsubscribe no-px2rem">
    <header><img class="logo" :src="logoImg" alt=""></header>
    <h2 class="title">{{content}}</h2>
    <div class="pic-box">
      <img class="logo" src="https://img0.didiglobal.com/static/soda_static/m/act/static/img/pic.jpg" alt="">
    </div>
  </section>
</template>
<script>
import imgDidi from '@/assets/images/logo.png'
import img99 from '@/assets/images/logo-99@3x.png'
import { getLocaleBrandText } from '@/common/js/utils'
import { sprintf } from '@didi/gettext'
export default {
  name: 'unsubscribeResult',
  components: {

  },
  data () {
    return {
    }
  },
  computed: {
    country () {
      return this.$store.state.country
    },
    logoImg () {
      let imgurl = ''
      // 两种方式，一种将图片资源放在最外层static目录下，另一种是通过import方式引进来
      if (this.country === 'BR') {
        imgurl = img99
      } else if (this.country === 'MX') {
        imgurl = imgDidi
      } else {
        imgurl = imgDidi
      }

      return imgurl
    },
    content () {
      return sprintf(this.gettext('很遗憾您无法接收我们的最新消息了，感谢您使用%s！'), getLocaleBrandText('brand_txt_1'))
    }
  }
}
</script>
<style lang="scss" scoped>
.unsubscribe {
  background-color: white;
  color: #333;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  header{
    padding: 48px;
    .logo{
      width: 220px;
    }
  }
  .title{
    font-size: 32px;
    font-weight: bold;
    line-height: 50px;
    padding: 30px 48px;
  }
  .pic-box{
    margin-top: 120px;
    width: 100%;
    text-align: center;
  }
  .pic-box.no-px2rem{
    margin-top: 104px;
    width: 100%;
    text-align: center;
  }
}
</style>